import getCookies from './get-cookies.js';
import getContentTypes from './get-content-types.js';
import getRoyalties from './get-royalties.js';
import decodeToken from './decode-token.js';
import hasAnyRole from './has-any-role.js';
import { PARTNER_ROLES } from './constants.js';

export function readSession(context) {
  const token = getCookies(context)?.auth_token;
  const { userId, roles } = decodeToken(token);

  return { token, userId, roles };
}

async function loadContentTypes(token) {
  if (!token) return [];

  return getContentTypes(token);
}

async function loadRoyalties({ token, roles }) {
  if (!hasAnyRole(roles, PARTNER_ROLES)) return [];

  return getRoyalties(token);
}

export default async function loadStoreContext(session) {
  const [contentTypes, royalties] = await Promise.all([
    loadContentTypes(session.token),
    loadRoyalties(session),
  ]);

  return { ...session, contentTypes, royalties };
}
